import { render, staticRenderFns } from "./Equipo_Lista.vue?vue&type=template&id=604150ee&scoped=true&"
import script from "./Equipo_Lista.vue?vue&type=script&lang=js&"
export * from "./Equipo_Lista.vue?vue&type=script&lang=js&"
import style0 from "./Equipo_Lista.vue?vue&type=style&index=0&id=604150ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604150ee",
  null
  
)

export default component.exports